module.exports = __webpack_public_path__ + "static/media/comp2_trans.51c54148.png";